import { SubscriptionState } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/subscriptions_pb";

// Provider-agnostic subscription state labels (works for both Chargify and
// Zuora), sourced from the subscriptions.v1.SubscriptionData proto.
export const subscriptionStateDisplayMapping = {
  [SubscriptionState.UNSPECIFIED]: "Unspecified",
  [SubscriptionState.ACTIVE]: "Active",
  [SubscriptionState.TRIALING]: "Trialing",
  [SubscriptionState.PAST_DUE]: "Past Due",
  [SubscriptionState.CANCELED]: "Canceled",
};
